import React from 'react';
import { Icon } from './Icon.js';
export const IconBoltLightning = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13 8.00004H20V9.00004L11 22L9.5 22L11 14H5L7.5 2H14L13 8.00004Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBoltLightning.js.map